import { Injectable } from "@angular/core";
import { MCEnvironmentsService, MCStore } from "@maslul/common-services";
import { ApplicantDetails } from "../../models/applicant/applicant-details";
import { Observable } from "rxjs";

export class ApplicantDetailsStoreData {
    applicant: ApplicantDetails | undefined;
}
const APPLICANT_DETAILS: ApplicantDetailsStoreData =
{
    applicant: undefined
}

@Injectable({
    providedIn: 'root',
})
export class ApplicantDetailsStore extends MCStore<ApplicantDetailsStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', APPLICANT_DETAILS, environmentsService);
    }


    getApplicant(): Observable<ApplicantDetails | undefined> {
        return this.select(s => s.applicant);
    }

    setApplicant(applicant: ApplicantDetails) {
        this.updateState('[ Applicant Details MCStore Service] set applicant', { applicant })
    }
}